import React, { useEffect, useState } from 'react'
import clsx from "clsx";

type ResponsiveCount = {
  sm?: number;
  md?: number;
  lg?: number;
  xl?: number;
};

type Props = {
    children : React.ReactNode,
    count : number | ResponsiveCount
    gap: number
}

const Grid = ({ children, count = 2, gap = 3 }: Props) => {
  const getGridColsClasses = () => {
    if (typeof count === 'number') {
      return {
        "grid-cols-1": count === 1,
        "grid-cols-2": count === 2,
        "grid-cols-3": count === 3,
        "grid-cols-4": count === 4,
      };
    }

    // Responsive object
    const responsive = count as ResponsiveCount;
    return {
      "grid-cols-1": true, // Default for mobile
      "sm:grid-cols-1": responsive.sm === 1,
      "sm:grid-cols-2": responsive.sm === 2,
      "sm:grid-cols-3": responsive.sm === 3,
      "sm:grid-cols-4": responsive.sm === 4,
      "md:grid-cols-1": responsive.md === 1,
      "md:grid-cols-2": responsive.md === 2,
      "md:grid-cols-3": responsive.md === 3,
      "md:grid-cols-4": responsive.md === 4,
      "lg:grid-cols-1": responsive.lg === 1,
      "lg:grid-cols-2": responsive.lg === 2,
      "lg:grid-cols-3": responsive.lg === 3,
      "lg:grid-cols-4": responsive.lg === 4,
      "xl:grid-cols-1": responsive.xl === 1,
      "xl:grid-cols-2": responsive.xl === 2,
      "xl:grid-cols-3": responsive.xl === 3,
      "xl:grid-cols-4": responsive.xl === 4,
    };
  };

  return (
    <div
      className={clsx(
        "grid items-start",
        getGridColsClasses(),
        {
          "gap-1": gap === 1,
          "gap-2": gap === 2,
          "gap-3": gap === 3,
          "gap-4": gap === 4,
          "gap-5": gap === 5,
          "gap-6": gap === 6,
        }
      )}
    >
      {children}
    </div>
  );
};

export default Grid